<template>
    <div id="add">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-book"></i> Lessons</div>
        </div>
        <hr>
        <form class="box">
            <div class="columns is-multiline">              
                <div class="column is-6">
                    <div class="field">
                      <bulma-input name="provider_id" v-model="lesson.provider_id" rules="required" placeholder='Provider id'/>
                    </div>
                </div>

                <div class="column is-6">
                    <div class="field">
                        <bulma-input name="name" v-model="lesson.name" rules="required" placeholder='Name'/>
                    </div>
                </div>

                <div class="column is-6">
                    <div class="field">
                        <bulma-input name="name" v-model="lesson.words" rules="required" placeholder='Words'/>
                    </div>
                </div>

                <div class="column is-6" v-if="schools && schools.length > 0">
                    <div class="field">
                        <div class="select is-fullwidth">
                            <select v-model="lesson.school_id">
                                <option v-bind:value="school.id" v-for="school in schools">{{school.name}}</option>
                            </select>
                        </div>
                    </div>
                </div>               

            </div>
            <div class="columns is-multiline"> 
                <div class="column is-2">                    
                    <loading-button v-bind:loading="loading" color="is-info" @click="save()">Save</loading-button>                    
                </div>              
                <div class="column is-2 is-offset-8 is-pulled-right">                                           
                    <a href="javascript:history.go(-1)" class="button is-block">
                        Back
                    </a>                   
                </div>              
            </div>                      
        </form>
    </div>  
</template>

<script>
import LessonRepo from '../../repos/LessonRepo'
import SchoolRepo from '../../repos/SchoolRepo'
import lodash from 'lodash'

export default {
  name: 'lessons-add',
  components: {},
  data() {
        return {
            repo: new LessonRepo(this.$auth),
            schoolRepo: new SchoolRepo(this.$auth),
            loading: false,
            schools: [],
            lesson: {},
        }
  },
  created(){  
    this.getSchools();
  },
  methods: {
    getSchools(){
        this.schoolRepo.all().then(response => {
            this.schools = response.data.data;
            if(this.schools && this.schools.length > 0){
                this.lesson.school_id = this.schools[0].id;
            }

        });         
    },
    save(){            
        this.$validator.validateAll().then((result) => {
	    if (result) {
                let self = this;
                this.loading = true;
                this.repo.store(this.lesson).then(function (response) {
                    self.loading = false;
                    self.$toast.success(response.data.message);
                    self.$router.push('/dashboard/lessons');
                }).catch(function(response){
                    self.loading = false;                    
                    return Promise.reject(response);
                });
            }
        });
    
    },
  },
  watch: {
       
  }
  
}
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/lessons/Add.vue